var render, staticRenderFns
import script from "./PolarArea.vue?vue&type=script&lang=js&"
export * from "./PolarArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c602a",
  null
  
)

export default component.exports